export default __webpack_public_path__ + "static/media/canadianTravel.2ce22f42.jpg";